// @flow
import styled from 'styled-components';

export const PlayerRowMenuCloseButton = styled.div`
	height: 60px;
	width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
`;

export default PlayerRowMenuCloseButton;


// WEBPACK FOOTER //
// ./src/components/PlayerRowMenuCloseButton/index.js